// extracted by mini-css-extract-plugin
export var article = "Article-module--article--bq28g";
export var aside = "Article-module--aside--4Z364";
export var blocksAfterContent = "Article-module--blocksAfterContent--el4rT";
export var pageFooter = "Article-module--pageFooter--jKzup";
export var scrollUp = "Article-module--scrollUp--5MfPH";